export default __webpack_public_path__ + "9fc4b5a94d0aa3daed451b4b81fcc590.png";